"use client";

import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import { useRouter } from "next/navigation";

import { useEffect, useState, createContext, useContext } from "react";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const axiosPublicInstance = useAxiosPublicInstance();
  const router = useRouter();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    if (storedCustomer) {
      setCustomer(JSON.parse(storedCustomer));
    }
  }, []);

  async function register(customerData) {
    try {
      const response = await axiosPublicInstance.post(
        "REGISTER_API",
        customerData
      );

      if (response.data) {
        setCustomer(response.data);
        toast.success("Registration Successful");
        localStorage.setItem("customer", JSON.stringify(response.data));
      }
      return response.data;
    } catch (error) {
      toast.success(error?.response?.data?.message);
    }
  }

  async function login(customerData) {
    try {
      const response = await axiosPublicInstance.post(
        "LOGIN_API",
        customerData
      );

      if (response.data) {
        setCustomer(response.data);
        localStorage.setItem("customer", JSON.stringify(response.data));
        toast.success("Login Successful");
        router.push("/");
      }
      return response.data;
    } catch (error) {
      toast.success(error?.response?.data?.message);
    }
  }

  function logout() {
    setCustomer(null);
    localStorage.removeItem("customer");
    toast.success("User Logged out");
    router.push("/");
  }

  const values = {
    register,
    login,
    logout,
    customer,
    isLoading,
    setCustomer,
    setShowModal,
    showModal,
    showLoginModal,
    setShowLoginModal,
  };

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
